// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__iBMGP","noInteraction":"EventWrapper_noInteraction__3KNtw","pointerPassthrough":"EventWrapper_pointerPassthrough__2db-W"};